module.exports = __webpack_public_path__ + "196eca589947de166c3f0298e6a01744.pdf";